import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function HelpTab({ theme, baseUrl, t, }) {
    const text = theme.primaryTextColor || theme.contentColor || theme.foreground;
    const muted = theme.secondaryTextColor || "#64748b";
    const cardBg = theme.cardBackgroundColor || theme.secondaryBackground || "#ffffff";
    const borderColor = "#d8e0eb";
    const sectionBg = theme.background || "#f4f7fb";
    const gradientBase = theme.homepageGradientBaseColor || "#d9e1ec";
    const sections = [
        { title: t("help.howTitle"), body: t("help.howBody", { baseUrl }), icon: "i" },
        { title: t("help.embedTitle"), body: t("help.embedBody"), icon: "</>" },
        { title: t("help.themeTitle"), body: t("help.themeBody"), icon: "\u25a1" },
    ];
    return (_jsxs("div", { style: { padding: 16, display: "grid", gap: 12, color: text, background: sectionBg, position: "relative" }, children: [_jsx("div", { "aria-hidden": true, style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "70%",
                    background: `linear-gradient(180deg, ${gradientBase} 0%, ${sectionBg} 100%)`,
                    pointerEvents: "none",
                    zIndex: 0,
                } }), sections.map((section) => (_jsxs("div", { style: {
                    borderRadius: 14,
                    border: `1px solid ${borderColor}`,
                    background: cardBg,
                    padding: 12,
                    display: "grid",
                    gap: 8,
                    position: "relative",
                    zIndex: 1,
                }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [_jsx("div", { style: {
                                    width: 24,
                                    height: 24,
                                    borderRadius: 8,
                                    background: theme.accentColor,
                                    color: "#ffffff",
                                    fontSize: 11,
                                    fontWeight: 800,
                                    display: "grid",
                                    placeItems: "center",
                                }, children: section.icon }), _jsx("div", { style: { fontWeight: 700 }, children: section.title })] }), _jsx("p", { style: { fontSize: 14, color: muted, lineHeight: 1.5, margin: 0 }, children: section.body })] }, section.title)))] }));
}
